import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { useTheme } from "../../../context/theme-context";

interface MessageDataPoint {
  date: string;
  total: number;
  promotional: number;
  transactional: number;
}

interface MessageTrendsChartProps {
  data: MessageDataPoint[];
}

export const MessageTrendsChart: React.FC<MessageTrendsChartProps> = ({ data }) => {
  const { isDark } = useTheme();
  const gridColor = isDark ? "#374151" : "#e5e7eb";
  const axisColor = isDark ? "#9ca3af" : "#6b7280";

  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Message Trends</h3>
      </div>

      <div className="w-full h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
            <XAxis dataKey="date" stroke={axisColor} tick={{ fill: axisColor }} />
            <YAxis stroke={axisColor} tick={{ fill: axisColor }} />
            <Tooltip
              contentStyle={{
                borderRadius: 8,
                borderColor: isDark ? "#374151" : "#ccc",
                backgroundColor: isDark ? "#1f2937" : "#fff",
                color: isDark ? "#f3f4f6" : "#111827",
              }}
            />
            <Legend wrapperStyle={{ color: axisColor }} />
            <Line type="monotone" dataKey="total" stroke="#3B82F6" strokeWidth={2} name="Total" />
            <Line type="monotone" dataKey="promotional" stroke="#F97316" strokeWidth={2} name="Promotional" />
            <Line type="monotone" dataKey="transactional" stroke="#10B981" strokeWidth={2} name="Transactional" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
